export default {
  name: 'fetchesMixin',
  data() {
    return {
      countries: [],
      countriesSelect: [],
      countriesById: [],
      countriesByIdSelect: [],
      deliveryTimeRanges: [],
      deliveryTimeRangesSelect: [],
      areas: [],
      areasSelect: [],
      areasWithCoords: [],
      routingZones: [],
      routingZonesSelect: [],
      routingZonesWithCoords: [],
      warehouses: [],
      warehousesSelect: [],
      warehousesByIdSelect: [],
      shippingSizes: [],
      shippingSizesSelect: [],
      shippingTypes: [],
      shippingTypesSelect: [],
      platforms: [],
      platformsSelect: [],
      vehicleTypes: [],
      vehicleTypesSelect: [],
      roles: [],
      rolesSelect: [],
      receiverTypes: [],
      tobereturnedStatusReasons: [],
      shippingStatusReasons: {},
      eventTypes: [],
      eventTypesSelect: [],
      notificationTypes: [],
      notificationTypesSelect: [],
      industries: [],
      industriesSelect: [],
      companiesSettings: [],
      companiesSegments: [],
      companiesSegmentsSelect: [],
      disableReasons: [],
      disableReasonsSelect: [],
      services: [],
      servicesSelect: [],
      outsourcingModelMappings: [],
      outsourcingModelMappingsSelect: [],
      platforms3p: [],
      platforms3pSelect: [],
      outsourcingCustomizations: [],
      outsourcingCustomizationsSelect: []
    }
  },
  methods: {
    async fetchCountries(params) {
      if (!params) {
        params = {
          sort: [
            {
              key: 'name',
              direction: 'asc'
            }
          ]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'countries', { params: params })
        .then(response => {
          this.countries = response.body.data
          this.countriesSelect = this.countries.map((item) => {
            return {
              value: item.iso_code,
              text: item.name
            }
          })
          this.countriesByIdSelect = this.countries.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Countries Fetched OK!')
        })
    },
    async fetchCountriesById(params) {
      if (!params) {
        params = {
          sort: [
            {
              key: 'name',
              direction: 'asc'
            }
          ]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'countries', { params: params })
        .then(response => {
          this.countriesById = response.body.data
          this.countriesByIdSelect = this.countriesById.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Countries By ID Fetched OK!')
        })
    },
    async fetchDeliveryTimeRanges(country = null, includes = []) {
      let params = {}
      country = country || window.country
      if (country !== null) {
        let countryId = window.countries.find(x => x.iso_code === country).id
        params = {
          filter_groups: [{
            filters: [
              ['country_id', 'eq', countryId]
            ]
          }]
        }
      }
      if (includes.length > 0) {
        params.includes = includes
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'delivery-time-ranges', {params: params})
        .then(response => {
          this.deliveryTimeRanges = response.body.data
          this.deliveryTimeRangesSelect = this.deliveryTimeRanges.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Delivery Time Ranges Fetched OK!')
        })
    },
    async fetchRegions(country = null, includes = []) {
      let params = {}
      country = country || window.country
      if (country !== null) {
        params = {
          filter_groups: [{
            filters: [
              ['country_iso_code', 'eq', country]
            ]
          }]
        }
      }
      if (includes.length > 0) {
        params.includes = includes
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'regions', {params: params})
        .then(response => {
          this.regions = response.body.data
          this.regionsSelect = this.regions.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Regions Fetched OK!')
        })
    },
    async fetchAreas(country = null, includes = [], prevItems = [], page = 0) {
      let params = {}
      country = country || window.country
      if (country !== null) {
        params = {
          filter_groups: [{
            filters: [
              ['country', 'eq', country]
            ]
          }]
        }
      }
      if (includes.length > 0) {
        params.includes = includes
      }
      params.sort = [
        {
          key: 'name',
          direction: 'asc'
        }
      ]
      params.page = page
      return await this.$http.get(this.$appConfig.api.baseUrl + 'areas', {params})
        .then(async response => {
          if (response.body.data.length > 0) {
            prevItems = prevItems.concat(response.body.data)
            await this.fetchAreas(country, includes, prevItems, response.body.pagination.page + 1)
          } else {
            this.areas = prevItems
            this.areasSelect = prevItems.map((item) => {
              return {
                value: item.id,
                text: item.name
              }
            })
            this.areasWithCoords = prevItems.map((item) => {
              return {
                id: item.id,
                text: item.name,
                value: {
                  coords: JSON.parse(JSON.stringify(item.area)).coordinates.map(linearRing =>
                    linearRing.slice(0, linearRing.length - 1)
                      .map(([lng, lat]) => ({lat, lng}))
                  )
                }
              }
            })
            console.log('Areas Fetched OK!')
          }
        })
    },
    async fetchRoutingZones(country = null, includes = [], prevItems = [], page = 0) {
      let params = {}
      country = country || window.country
      if (country !== null) {
        params = {
          filter_groups: [{
            filters: [
              ['country_iso_code', 'eq', country]
            ]
          }]
        }
      }
      if (includes.length > 0) {
        params.includes = includes
      }
      params.sort = [
        {
          key: 'name',
          direction: 'asc'
        }
      ]
      params.page = page
      return await this.$http.get(this.$appConfig.api.baseUrl + 'routing-zones', {params})
        .then(async response => {
          if (response.body.data.length > 0) {
            prevItems = prevItems.concat(response.body.data)
            await this.fetchRoutingZones(country, includes, prevItems, response.body.pagination.page + 1)
          } else {
            this.routingZones = prevItems
            this.routingZonesSelect = prevItems.map((item) => {
              return {
                value: item.id,
                text: item.name
              }
            })
            this.routingZonesWithCoords = prevItems.map((item) => {
              return {
                id: item.id,
                text: item.name,
                value: {
                  coords: JSON.parse(JSON.stringify(item.area)).coordinates.map(linearRing =>
                    linearRing.slice(0, linearRing.length - 1)
                      .map(([lng, lat]) => ({lat, lng}))
                  )
                }
              }
            })
            console.log('Routing Zones Fetched OK!')
          }
        })
    },
    async fetchWarehouses(country = null, includes = []) {
      let params = {}
      country = country || window.country
      if (country !== null) {
        params = {
          filter_groups: [{
            filters: [
              ['country_iso_code', 'eq', country]
            ]
          }]
        }
      }
      if (includes.length > 0) {
        params.includes = includes
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'warehouses', {params: params})
        .then(response => {
          this.warehouses = response.body.data
          this.warehousesSelect = this.warehouses.map((item) => {
            return {
              value: item.place_id,
              text: item.reference
            }
          })
          console.log('Warehouses Fetched OK!')
        })
    },
    async fetchWarehousesById(country = null, includes = []) {
      let params = {}
      country = country || window.country
      if (country !== null) {
        params = {
          filter_groups: [{
            filters: [
              ['country_iso_code', 'eq', country]
            ]
          }]
        }
      }
      if (includes.length > 0) {
        params.includes = includes
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'warehouses', {params: params})
        .then(response => {
          this.warehousesById = response.body.data
          this.warehousesByIdSelect = response.body.data.map((item) => {
            return {
              value: item.id,
              text: item.reference
            }
          })
          console.log('Warehouses By ID Fetched OK!')
        })
    },
    async fetchShippingSizes() {
      let params = {
        params: {
          sort: [{
            key: 'max_weight',
            direction: 'asc'
          }]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'sizes', params)
        .then(response => {
          this.shippingSizes = response.body.data
          this.shippingSizesSelect = this.shippingSizes.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Shipping Sizes Fetched OK!')
        })
    },
    async fetchShippingTypes() {
      let params = {
        params: {
          sort: [{
            key: 'name',
            direction: 'asc'
          }]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'shipping-types', params)
        .then(response => {
          this.shippingTypes = response.body.data
          this.shippingTypesSelect = this.shippingTypes.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Shipping Types Fetched OK!')
        })
    },
    async fetchPlatforms() {
      let params = {
        params: {
          sort: [{
            key: 'name',
            direction: 'asc'
          }]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'platforms', params)
        .then(response => {
          this.platforms = response.body.data
          this.platformsSelect = this.platforms.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Platforms Fetched OK!')
        })
    },
    async fetchVehicleTypes() {
      let params = {
        params: {
          sort: [{
            key: 'max_volume_allowed',
            direction: 'asc'
          }]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'vehicle-types', params)
        .then(response => {
          this.vehicleTypes = response.body.data
          this.vehicleTypesSelect = this.vehicleTypes.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Vehicle Types Fetched OK!')
        })
    },
    async fetchRoles(setDisabledsByRole = false) {
      let params = {
        params: {
          sort: [{
            key: 'name',
            direction: 'asc'
          }]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'roles', params)
        .then(response => {
          this.roles = response.body.data
          if (!this.isMoova) {
            this.roles.splice(this.roles.findIndex(x => x.name === 'super-admin'), 1)
          }
          this.rolesSelect = this.roles.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          }).filter(role => {
            if (role.text === this.$roles.SUPER_ADMIN) {
              if (this.isSuperAdmin) {
                return true
              } else {
                return false
              }
            }
            if (role.text === this.$roles.ADMIN) {
              if (this.isSuperAdmin || this.isAdmin) {
                return true
              } else {
                return false
              }
            }
            return this.isSuperAdmin ||
              this.isAdmin ||
              ((this.isOperatorSupervisor || this.isOnboarding) && (role.text === this.$roles.OPERATOR || role.text === this.$roles.WAREHOUSE_OPS)) ||
              role.text !== this.$roles.ADMIN &&
              role.text !== this.$roles.OPERATOR_SUPERVISOR &&
              role.text !== this.$roles.ACCOUNTANT &&
              role.text !== this.$roles.ACCOUNT_APPROVER &&
              role.text !== this.$roles.INTERNATIONAL &&
              role.text !== this.$roles.COMMERCIAL &&
              role.text !== this.$roles.OPERATOR &&
              role.text !== this.$roles.WAREHOUSE_OPS &&
              role.text !== this.$roles.INTEGRATOR &&
              role.text !== this.$roles.HEAD_OPERATIONS &&
              role.text !== this.$roles.HEAD_SALES &&
              role.text !== this.$roles.ONBOARDING &&
              role.text !== this.$roles.COURIER_ADMIN
          }).map(role => {
            if (setDisabledsByRole) {
              if (this.isSuperAdmin || this.isAdmin || this.isOnboarding || (this.isCourierAdmin && role.text === this.$roles.COURIER)) {
                return role
              } else {
                return {...role, disabled: true}
              }
            } else {
              return role
            }
          })
          console.log('Roles Fetched OK!')
        })
    },
    async fetchReceiverTypes() {
      return this.$http.get(this.$appConfig.api.baseUrl + 'receiver-types')
        .then(response => {
          this.receiverTypes = response.body.data
          console.log('Receiver Types Fetched OK!')
        })
    },
    async fetchShippingStatusReasons() {
      return this.$http.get(this.$appConfig.api.baseUrl + 'shipping-status-reasons')
        .then(response => {
          for (let i = 0; i < response.body.data.length; i++) {
            if (!this.shippingStatusReasons[response.body.data[i].event]) {
              this.shippingStatusReasons[response.body.data[i].event] = []
            }
            // reset the shipping_status_reasons events to match shipping statuses
            if (response.body.data[i].event === 'PICKEDUP') {
              response.body.data[i].event = 'CONFIRMED'
            } else if (response.body.data[i].event === 'DELIVERED') {
              this.tobereturnedStatusReasons.push({name: response.body.data[i].name, description: response.body.data[i].description, reason_id: response.body.data[i].id})
              response.body.data[i].event = 'INTRANSIT'
            }
            this.shippingStatusReasons[response.body.data[i].event].push({name: response.body.data[i].name, description: response.body.data[i].description, reason_id: response.body.data[i].id})
          }
          console.log('Shipping Status Reasons Fetched OK!')
        })
    },
    async fetchEventTypes() {
      let params = {
        params: {
          sort: [{
            key: 'name',
            direction: 'asc'
          }]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'event-types', params)
        .then(response => {
          this.eventTypes = response.body.data
          this.eventTypesSelect = this.eventTypes.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Event Types Fetched OK!')
        })
    },
    async fetchNotificationTypes() {
      let params = {
        params: {
          sort: [{
            key: 'name',
            direction: 'asc'
          }]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'notification-types', params)
        .then(response => {
          this.notificationTypes = response.body.data
          this.notificationTypesSelect = this.notificationTypes.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Notification Types Fetched OK!')
        })
    },
    async fetchIndustries() {
      const params = {
        // sort: [{
        //   key: 'description',
        //   direction: 'asc'
        // }],
        filter_groups: [
          {
            filters: [
              ['type', 'eq', 'industry']
            ]
          }
        ]
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'marketing-catalogs', {params: params})
        .then(response => {
          this.industries = response.body.data
          this.industriesSelect = this.industries.map((item) => {
            return {
              value: item.id,
              text: item.description
            }
          })
          console.log('Industries Fetched OK!')
        })
    },
    async fetchCompaniesSettings() {
      let params = {
        params: {
          sort: [{
            key: 'name',
            direction: 'asc'
          }]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'settings', params)
        .then(response => {
          this.companiesSettings = response.body.data
          console.log('Companies Settings Fetched OK!')
        })
    },
    async fetchCompaniesSegments() {
      let params = {
        params: {
          sort: [{
            key: 'id',
            direction: 'asc'
          }]
        }
      }
      return await this.$http.get(this.$appConfig.api.baseUrl + 'companies-segments', params)
        .then(response => {
          this.companiesSegments = response.body.data
          this.companiesSegmentsSelect = this.companiesSegments.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Companies Segments Fetched OK!')
        })
    },
    async fetchDisableReasons() {
      let params = {
        params: {
          sort: [{
            key: 'name',
            direction: 'asc'
          }]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'disable-reasons', params)
        .then(response => {
          this.disableReasons = response.body.data
          this.disableReasonsSelect = this.disableReasons.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Disable Reasons Fetched OK!')
        })
    },
    async fetchServices() {
      return this.$http.get(this.$appConfig.api.baseUrl + 'services')
        .then(response => {
          this.services = response.body.data
          this.servicesSelect = this.services.map((item) => {
            return {
              value: item.id,
              text: item.description || item.name
            }
          })
          console.log('Services Fetched OK!')
        })
    },
    async fetchOutsourcingModelMappings() {
      return this.$http.get(this.$appConfig.api.baseUrl + 'outsourcing-model-mappings/mapeable-models')
        .then(response => {
          this.outsourcingModelMappings = response.body
          this.outsourcingModelMappingsSelect = this.outsourcingModelMappings.map((item) => {
            return {
              value: item,
              text: item
            }
          })
          console.log('Outsourcing Model Mappings Fetched OK!')
        })
    },
    async fetchPlatforms3p() {
      const params = {
        sort: [{
          key: 'name',
          direction: 'asc'
        }],
        filter_groups: [{
          filters: [
            ['name', 'ct', '[3p]']
          ]
        }]
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'platforms', {params})
        .then(response => {
          this.platforms3p = response.body.data
          this.platforms3pSelect = this.platforms3p.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('3P Platforms Fetched OK!')
        })
    },
    async fetchOutsourcingCustomizations() {
      return this.$http.get(this.$appConfig.api.baseUrl + 'outsourcing/customizations')
        .then(response => {
          this.outsourcingCustomizations = response.body.data
          this.outsourcingCustomizationsSelect = this.outsourcingCustomizations.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Outsourcing Customizations Fetched OK!')
        })
    }
  }
}
